import { getCompanyInstitutionContext } from "@/data/companies";
import { resolveInstitutionChannel } from "@/data/institutionChannels";

export const V1_SCOPE_STATUS = Object.freeze({
  ACTIVE: "active",
  SOON: "soon",
  HIDDEN: "hidden",
});

export const V1_SOON_CONTENT = Object.freeze({
  title: "Bu çözüm yakında",
  description: "Şehir ve hizmet sağlayıcıya göre doğru kurum kanalını hazırlıyoruz.",
});

export const V1_SUPPORTED_CATEGORIES = Object.freeze({
  cancellation: Object.freeze(["internet", "tv", "mobile", "digital"]),
  invoice: Object.freeze(["telecom"]),
  refund: Object.freeze(["online-product", "not-delivered", "cancelled-service", "digital", "defective"]),
});

export const V1_UNSUPPORTED_CATEGORY_IDS = Object.freeze([
  "electricity",
  "gas",
  "water",
  "bank",
  "dues",
  "ticket",
  "education",
  "deposit",
  "duplicate",
  "gym",
  "insurance",
  "other",
]);

export const V1_SUPPORTED_BILLING_PROVIDERS = Object.freeze([
  "direct",
  "google_play",
  "apple",
]);

export function getV1CategoryStatus(flow, categoryId) {
  return V1_SUPPORTED_CATEGORIES[flow]?.includes(categoryId)
    ? V1_SCOPE_STATUS.ACTIVE
    : V1_SCOPE_STATUS.SOON;
}

export function isV1BillingProviderSupported(value) {
  return V1_SUPPORTED_BILLING_PROVIDERS.includes(value);
}

export function getV1CompanyResolution(companyName, issueType) {
  const context = getCompanyInstitutionContext(companyName);
  if (!context?.companyId || !issueType) return null;
  const options = { serviceScope: context.serviceScope };
  if (context.category === "digital") options.billingProvider = "direct";
  if (context.category === "ecommerce") {
    options.commerceProblem = "return_product";
    if (context.companyId === "pttavm") options.purchaseAccountMode = "member";
  }
  return resolveInstitutionChannel(context.companyId, issueType, options);
}

export function hasV1VerifiedChannel(companyName, issueType) {
  return Boolean(getV1CompanyResolution(companyName, issueType)?.primaryChannel);
}

export function filterV1CompanyGroups(groups, issueType) {
  return groups.map((group) => ({
    ...group,
    items: group.items.filter((companyName) => hasV1VerifiedChannel(companyName, issueType)),
  })).filter((group) => group.items.length > 0);
}
